import React, { useEffect } from 'react';
import qs from 'qs';
import axios from 'axios';

interface IProps {
  client: any;
  searchIds: any[];
  isAccutitle: boolean;
  isAtr: boolean;
}

export default function IntegrationSendToClientWarning(props: IProps) {
  const [searchesNoInfo, setSearchesNoInfo] = React.useState<any[]>([]);
  useEffect(() => {
    if (props.searchIds.length > 0 && (props.client?.snapClientName || props.isAccutitle || props.isAtr)) {
      getSearchDetails(props.searchIds);
    }
  }, [props.client, props.searchIds]);

  const getText = () => {
    if (props.isAccutitle) {
      return 'Accutitle Number associated and will not be sent to Accutitle for delivery to';
    }
    if (props.isAtr) {
      return 'ATR Number associated and will not be sent to ATR for delivery to';
    }
    return 'SNAP Guid associated and will not be sent to SNAP for delivery to';
  }

  const getSearchDetails = async (searchIds: number[]) => {
    const queryParams = qs.stringify({ searchIds });
    const { data: searchDataArr } = await axios.get(`/api/searches/getBasicSearchInfo?${queryParams}`);
    const searchesNoData = searchDataArr.filter((s: any) => (props.client?.snapClientName && !s.snapGuid) || (props.isAccutitle && !s.accutitleNumber) || (props.isAtr && !s.atrNumber));
    setSearchesNoInfo(searchesNoData);
  };

  if ((!props.client?.snapClientName && !props.isAccutitle && !props.isAtr) || searchesNoInfo.length === 0) {
    return <React.Fragment />;
  }
  return (
    <div
      style={{
        width: '100%',
        minHeight: 75,
        border: '1px solid #ff9800',
        borderRadius: 4,
        whiteSpace: 'pre-wrap',
        marginTop: 8,
        padding: 8,
      }}
    >
      {searchesNoInfo.map(s => s.searchCode).join(', ')} search{searchesNoInfo.length === 1 ? '' : 'es'}
      {searchesNoInfo.length === 1 ? ' has' : ' have'} no {getText()} {props.client.name}.<br />
      Please use the old process for {searchesNoInfo.length === 1 ? 'this search' : 'these searches'}.
    </div>
  );
}
